import { useMemo } from "react";
import { OnboardingStepName } from "@platform/types/onboarding.types";
import {
  STEP_COMPLETED,
  useOnboarding,
  useOnboardingDispatch,
} from "../OnboardingContext";

export function useOnboardingStep() {
  const dispatch = useOnboardingDispatch();

  const { steps } = useOnboarding();

  const currentStep = useMemo(
    () => steps.find((step) => step.isActive && !step.isCompleted),
    [steps]
  );

  const getStep = (stepName: OnboardingStepName) =>
    steps.find((step) => step.name === stepName);

  const completeStep = (stepName: OnboardingStepName) =>
    dispatch({ type: STEP_COMPLETED, payload: { stepName } });

  return {
    currentStep,
    getStep,
    completeStep,
  };
}

export default useOnboardingStep;
